// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.NumericInput_input__As54b {
  width: 100%;
  padding: 0.375rem 0.75rem;
  color: #495057;
  background-color: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.NumericInput_input__As54b:disabled {
  color: #a0a0a0;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/Misc/NumericInput.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,WAAA;EACA,yBAAA;EAEA,cAAA;EAEA,uBAAA;EACA,yBAAA;EACA,sBAAA;AAaF;AAXE;EACE,cDMO;ACOX","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.input {\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  color: #495057;\n  background-color: white;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n.input:disabled {\n  color: #a0a0a0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `NumericInput_input__As54b`
};
export default ___CSS_LOADER_EXPORT___;
